import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev";
import { AOPUkraineRequestData } from "@/src/types/admissionOffice";
import type { RequestLetterBasicCountry } from "./requestLetterBasicRegistry";

const emptyRequestState = (): AOPUkraineRequestData => ({
  whose_doc: "",
  currentDate: "",
  fullName: "",
  fullNameEn: "",
  dateOfBirth: "",
  passportNumber: "",
  withPrint: false,
  bodyPV: [],
  documentNumber: "",
  secondBody: [],
});

export interface AOPRequestLetterBasicLayoutProps {
  country: RequestLetterBasicCountry;
}

const AOPRequestLetterBasicLayout = ({ country }: AOPRequestLetterBasicLayoutProps) => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPUkraineRequestData>(emptyRequestState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPUkraineRequestData>(emptyRequestState);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        country={country}
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
      />
      <AOPPrev country={country} bodyForPrev={bodyForPrev} />
    </div>
  );
};

export default AOPRequestLetterBasicLayout;
